<template>
    <div class="search-filter__container">
        <button :class="['search-filter__open-button', {'is-open': isPanelOpen}]"
                @click="toggleFilter"
                aria-label="Открыть панель поиска">
            <SearchIcon />
            <CloseIcon />
        </button>
        <div ref="filterWrapper" :class="['search-panel__filter', {'is-open': isPanelOpen,
            'is-collapsed': isCollapsed}]">
            <button @click="closeFilter" class="search-panel__filter-close" aria-label="Закрыть панель поиска">
                <svg width="12" height="12">
                    <use xlink:href="/webicons/sprite.svg#i-close"></use>
                </svg>
            </button>
            <div class="search-panel__filter-form-wrapper">
                <form ref="form" action="/" method="post" class="search-panel__filter-form">
                    <div v-if="windowWidth < 960" class="search-panel__filter-form-title h2">
                        Выбрать недвижимость
                    </div>
                    <div class="search-panel__form-input search-panel__form-input_theme_flat">
                        <MultiSelect v-if="!isEmpty(types)"
                                     modify="multi-select_theme_radio"
                                     type="radio"
                                     :select="types"
                                     :windowWidth="windowWidth"
                                     @change="emitSend(true)"/>
                    </div>
                    <div class="search-panel__form-input">
                        <MultiSelect v-if="!isEmpty(rooms)"
                                     modify="multi-select_theme_simple"
                                     type="checkbox"
                                     :select="rooms"
                                     :windowWidth="windowWidth"
                                     @change="emitSend"/>
                    </div>
                    <div :class="['search-panel__form-input', 'search-panel__form-input_theme_objects',
                            {'is-wide': isEmpty(rooms)}
                         ]">
                        <input v-for="(type, index) in objectsEstateTypes"
                               :key="index"
                               type="checkbox"
                               :name="`estateType${type[0].toUpperCase()}${type.slice(1)}`"
                               :checked="isObjectChecked(type)"
                               hidden>
                        <MultiSelect v-if="!isEmpty(objects)"
                                     modify="multi-select_theme_simple"
                                     type="checkbox"
                                     :select="objects"
                                     :windowWidth="windowWidth"
                                     @change="emitSend"/>
                    </div>
                    <RangeSlider v-if="!isEmpty(price)"
                                 :slider="price"
                                 :changed="priceChange"
                                 @change="emitSend"/>
                    <ResultButton v-if="!isEmpty(link)"
                                  :link="link"
                                  :windowWidth="windowWidth" />
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import CloseIcon from '../media/close-icon.vue';
import MultiSelect from '../MultiSelect/MultiSelect.vue';
import RangeSlider from '../RangeSlider/RangeSlider.vue';
import ResultButton from '../ResultButton/ResultButton.vue';
import SearchIcon from '../media/search-icon.vue';
import {Utils} from 'common/scripts/utils';

export default {
    props: ['data', 'isCollapsed', 'isMobile', 'isPanelOpen', 'priceChange', 'windowWidth'],

    data() {
        return {
            isFixed: false
        };
    },

    components: {
        CloseIcon,
        MultiSelect,
        RangeSlider,
        ResultButton,
        SearchIcon
    },

    computed: {
        types() {
            return this.data.types || null;
        },

        rooms() {
            return this.data.rooms || null;
        },

        objects() {
            return this.data.objects || null;
        },

        price() {
            return this.data.price || null;
        },

        link() {
            return this.data.link || null;
        },

        // Типы недвижимости объектов
        objectsEstateTypes() {
            const types = [];

            if (this.data.objects && this.data.objects.options) {
                for (const object of this.data.objects.options) {
                    if (object.estateType && !types.includes(object.estateType)) {
                        types.push(object.estateType);
                    }
                }
            }

            return types;
        }
    },

    watch: {
        isPanelOpen() {
            if (this.isPanelOpen) {
                if (this.isMobile) {
                    Utils.bodyFixed(this.$refs.filterWrapper);
                    this.isFixed = true;
                } else if (this.isFixed) {
                    Utils.bodyStatic();
                }
            } else if (this.isMobile) {
                Utils.bodyStatic();
                this.isFixed = false;
            }
        },

        isMobile() {
            if (this.isFixed) {
                Utils.bodyStatic();
                this.isFixed = false;
            }
        }
    },

    methods: {
        toggleFilter() {
            if (this.isPanelOpen) {
                this.closeFilter();
            } else {
                this.openFilter();
            }
        },

        openFilter() {
            this.$emit('openFilter');
        },

        closeFilter() {
            this.$emit('closeFilter');
        },

        /**
         * При изменении фильтра,
         * отправляем данные на бэк
         * @param {Boolean} isTypeChanged - изменился ли тип помещений
         */
        emitSend(isTypeChanged = false) {
            this.$emit('changeFilter', this.$refs.form, isTypeChanged, this.priceChanged);
        },

        /**
         * Проверяет объект на пустоту
         * @param {Object} obj - проверяемый объект
         * @return {boolean|boolean} - true, если пустой
         */
        isEmpty(obj) {
            if (!obj) {
                return true;
            }

            return Object.keys(obj).length === 0 && obj.constructor === Object;
        },

        /**
         * Проверяет, выбран ли хотя бы один из объектов данного типа
         * @param {String} type - название типа недвижимости
         * @return {boolean} - да/нет
         */
        isObjectChecked(type) {
            let typeSelect = false;

            this.objects.options.filter((object) => {
                return object.estateType === type;
            }).forEach((object) => {
                if (object.selected) {
                    typeSelect = true;
                }
            });

            return typeSelect;
        }
    }
};
</script>
